<template>
  <div class="tongyongdl">
    <div class="tongyongcard">
      <img src="../../../../assets/images/shipancard.png" />
      <p
        style="
          color: #0e286d;
          line-height: 20px;
          letter-spacing: 1px;
          font-size: 14px;
        "
      >
        这是一款<common-data name="tollSoftWare"/>，需要授权账号/密码才能登录。
      </p>
    </div>
    <div class="tongyongbody">
      <div class="tongyongbodydl">
        <div class="tongyongdllf">
          <h4
            style="
              color: #1e5c88;
              line-height: 50px;
              height: 50px;
              padding-top: 30px;
              letter-spacing: 1px;
            "
          >
            使用应满足的条件
          </h4>
          <ResTxt class="waflls" id="c1c225656b28f" /><br>
          <ResTxt class="waflls" style="padding-left: 1.6em; text-indent: -1.6em;width: 370px;" id="b6f82be71fb05" /><br>
          <ResTxt class="waflls" id="3dc3a7177e426" /><br>
          <ResTxt class="waflls" id="212f392bd4c95" /><br>
          <!-- <p class="waflls">1、X86架构的4线程CPU/8G内存（RAM），或更高配置；</p>
          <p class="waflls">2、硬盘空间要求：操作系统盘与软件安装盘的剩余可用空<br><span style="margin-left:26px">间分别都>20G（或硬盘总容量的20%）；</span></p>
          <p class="waflls">3、windows7、windows10等64位操作系统；</p>
          <p class="waflls">4、建议使用电信、联通宽带，其它宽带会有卡顿的问题。</p> -->
        </div>
        <div class="tongyongdlrg">
          <div class="dlbutton">
            <div
              style="
                background: #364064;
                border-radius: 0.5em;
                height: 45px;
                width: 140px;
                color: white;
                font-size: 18px;
                line-height: 45px;
                text-align: center;
                float: right;
                margin-right: 40px;
                cursor: pointer;
              "
              @click="liantong"
            >
              <img
                src="../../../../assets/images/xiazai.png"
                style="padding-right: 5px"
              />联通下载
            </div>
            <div
              style="
                background: #c4954d;
                border-radius: 0.5em;
                height: 45px;
                width: 140px;
                color: white;
                font-size: 18px;
                line-height: 45px;
                text-align: center;
                float: right;
                margin-right: 60px;
                cursor: pointer;
              "
              @click="dianxin"
            >
              <img
                src="../../../../assets/images/xiazai.png"
                style="padding-right: 5px"
              />电信下载
            </div>
          </div>
          <div
            style="
              font-size: 12px;
              height: 14px;
              line-height: 14px;

              color: #9b9b9c;
              letter-spacing: 0.5px;
            "
          >
            {{ tybanben }}
          </div>
          <div
            style="
              width: 330px;
              font-size: 12px;
              letter-spacing: 1px;
              padding: 5px 5px 0 5px;
              background: rgba(227, 233, 243, 0.7);
              position: absolute;
              bottom: 0;
              left: 0px;
            "
          >
            <img
              src="../../../../assets/images/care.png"
              style="vertical-align: top; margin-right: 2px"
            />
            <span style="color: #727983"
              >请在文华官网下载正版文华软件，文华官网下载不会</span
            >
            <br />
            <span style="padding-left: 18px; line-height: 24px; color: #727983"
              >以任何形式向你索要电话号码，请注意谨防上当。</span
            >
          </div>
        </div>
      </div>
      <div style="margin-left: 40px;margin-top:5px">
        <h4
          style="
            color: #1e5c88;
            line-height: 50px;
            height: 50px;
            padding-top: 30px;
            letter-spacing: 1px;
          "
        >
          登录实盘账号
        </h4>
        <ResTxt
          style="
            text-indent: 2em;
            margin-right: 20px;
            letter-spacing: 1px;
            font-size: 15px;
            height: auto;
          "
          class="h4p"
          id="49afcc03b11c9"
        />
        <!-- <p
          class="h4p"
          style="
            text-indent: 2em;
            margin-right: 20px;
            letter-spacing: 1px;
            font-size: 15px;
          "
        >
          如下图所示，在登录界面输入购买的授权账号及密码，即可登录行情。如需交易需点击“期货户/外盘户”按钮，在弹出窗口中选择开户公司，输入资金账号及密码，即可登录交易。
        </p> -->
        <div style="margin-top: 25px; margin-left: 120px; margin-bottom: 30px">
          <img src="https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=29" />
        </div>
      </div>
    </div>
    <pingjia></pingjia>
  </div>
</template>

<script>
import pingjia from "./pingjia.vue";
import ResTxt from '@/ResData/ResTxt'
import { jsonp } from "vue-jsonp";

export default {
  components: {
    pingjia,
    ResTxt
  },
  data() {
    return {
      tybanben: "",
      tydata: "",
    };
  },
  methods: {
    dianxin() {
      if (this.tydata.split("|")[0] == "") {
        alert("下载信息加载中，请稍后再试");
      } else {
        window.location.href =
          "//ftpc.wenhua.com.cn/files/wh7_setup_" +
          this.tydata.split("|")[0] +
          ".exe";
      }
    },
    liantong() {
      if (this.tydata.split("|")[0] == "") {
        alert("下载信息加载中，请稍后再试");
      } else {
        window.location.href =
          "//ftpc1.wenhua.com.cn/files/wh7_setup_" +
          this.tydata.split("|")[0] +
          ".exe";
      }
    },
    getpj() {},
  },

  mounted() {
    jsonp("https://db.wenhua.com.cn/inc/update.asp", {
      appid: 12,
      t: 0,
    },60000)
      .then((data) => {
        this.tydata = data;

        this.tybanben =
          "  版本:" +
          this.tydata.split("|")[0] +
          "" +
          " (第" +
          this.tydata.split("|")[3] +
          "次修改)" +
          "\xa0\xa0" +
          " 大小:" +
          this.tydata.split("|")[2] +
          "\xa0\xa0" +
          " 日期:" +
          this.tydata.split("|")[1];
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style>
.tongyongdl {
  width: 1004px;
  background: url("../../../../assets/images/1.png") no-repeat top;
  background-size: 100% 100%;
  min-height: 200px;
  filter: drop-shadow(0px 4px 2px #b9b9b8);
}
.tongyongcard {
  width: 980px;
  margin: 0 auto;
  height: 180px;

  text-align: center;
  padding-top: 30px;
}
.tongyongbody {
  width: 1004px;
  min-height: 633px;
}
.tongyongbodydl {
  width: 1004px;
  min-height: 190px;
}
.tongyongdllf {
  width: 450px;
  float: left;
  height: 190px;
  margin-left: 40px;
}
.tongyongdlrg {
  width: 380px;
  float: right;
  height: 190px;
  position: relative;
}
.h4p {
  height: 28px;
  line-height: 28px;
  color: #727983;
  letter-spacing: 1px;
  font-size: 14px;
}
.dlbutton {
  margin-top: 50px;
  height: 65px;
}

.yongpingjia {
  margin-top: 50px;
  letter-spacing: 1px;
  background: url("../../../../assets/images/pj.png") no-repeat left;
  margin-left: -9px;
  color: white;
  height: 40px;
  width: 110px;
  text-align: center;
  line-height: 30px;
}
.pingjiatable {
  width: 910px;
  min-height: 420px;
  margin: 0 auto;
}
.pingj {
  min-height: 70px;
  border-top: 1px dashed #8e8f90;
}
.pagebt {
  height: 25px;
  width: 25px;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  background: #ffffff;
  color: #a6a6a6;
  float: right;
  margin-left: 5px;
  margin-right: 5px;
  user-select: none;
  border: 1px solid #dfdfdf;
}
.clickpagebt {
  height: 25px;
  width: 25px;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  background: #044c7e;
  color: #ffffff;
  margin-left: 5px;
  margin-right: 5px;
  float: right;
  user-select: none;
  border: 1px solid #dfdfdf;
}
.notclick {
  height: 25px;
  width: 25px;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  background: #ffffff;
  color: #a6a6a6;
  float: right;
  margin-left: 5px;
  margin-right: 5px;
  pointer-events: none;
  user-select: none;
  border: 1px solid #dfdfdf;
}
.pjcss1 {
  padding-top: 15px;
  color: #5e5f5f;
  font-size: 14px;
  line-height: 25px;
  letter-spacing: 1px;
}
.pjcss2 {
  padding-bottom: 5px;
  letter-spacing: 1px;
  color: #868686;
  font-size: 12px;
  line-height: 25px;
}
</style>